import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AwayAdActionsPageRoutingModule } from './away-ad-actions-routing.module';

import { AwayAdActionsPage } from './away-ad-actions.page';
import { CustomPipesModule } from 'src/app/pipes/pipes.module';
import { InputMaskModule } from '@ngneat/input-mask';
import { ContactsModalCommonPageModule } from '../../ad-contacts/contacts-modal/common.module';

@NgModule({
  imports: [
    CommonModule, CustomPipesModule, FormsModule, ReactiveFormsModule, InputMaskModule, IonicModule, ContactsModalCommonPageModule,
    AwayAdActionsPageRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [AwayAdActionsPage],
  exports: [AwayAdActionsPage],
})

export class AwayAdActionsPageModule {}
